let LStorkeywords=localStorage['hkArr']!==undefined?JSON.parse(localStorage['hkArr']):[];

function hKReducer(state={keywords:LStorkeywords},action){
	//console.log(action)
	switch (action.type){
		case "addHK":
			return Object.assign({}, state, action);
		default:
			return state;
	}
}
export default hKReducer;